import React, { useState, useContext } from "react";
import { UserContext } from "../context/UserContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  User,
  BookOpen,
  Eye,
  EyeOff,
  Mail,
  Lock,
  UserCheck,
  Phone,
  MessageCircle,
} from "lucide-react";
import Footer from "../Footer";
import "../styles/UserLogin.css"; // External CSS

/* ------------------------- Forgot Password ------------------------- */
const ForgotPassword = ({
  email,
  setEmail,
  handleForgotPassword,
  backStep,
  setStep,
}) => (
  <div className="page-container bg-blue">
    <div className="card">
      <div className="card-header">
        <Mail className="icon-lg text-blue" />
        <h2>পাসওয়ার্ড রিসেট করুন</h2>
        <p>রিসেট লিংক পেতে আপনার রেজিস্টার করা ইমেইলটি লিখুন।</p>
      </div>
      <div className="form">
        <div className="input-wrapper">
          <Mail className="input-icon" />
          <input
            type="email"
            placeholder="আপনার ইমেইল"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button onClick={handleForgotPassword} className="btn btn-student">
          রিসেট লিংক পাঠান
        </button>
      </div>
      <div className="card-footer">
        <button onClick={() => setStep(backStep)} className="link">
          ← লগইনে ফিরে যান
        </button>
      </div>
    </div>
  </div>
);

/* ------------------------- CHILD COMPONENTS ------------------------- */

//  Role Selection
const RoleSelection = ({ handleRoleSelection }) => (
  <div className="page-container bg-blue baloo-da-2-tutor">
    <div className="card">
      <div className="card-header">
        <h1>স্বাগতম!</h1>
        <p>প্ল্যাটফর্মে আপনার ভূমিকা বেছে নিন</p>
      </div>

      <div className="button-group">
        <button
          onClick={() => handleRoleSelection("student")}
          className="btn btn-student"
        >
          <User className="icon" />
          <span>আমি স্টুডেন্ট</span>
        </button>

        <button
          onClick={() => handleRoleSelection("tutor")}
          className="btn btn-tutor"
        >
          <BookOpen className="icon" />
          <span>আমি টিউটর</span>
        </button>
      </div>
    </div>
  </div>
);

//  Student Account Check
const StudentAccountCheck = ({
  handleStudentAccountCheck,
  setCurrentStep,
  onPostTuition,
}) => (
  <div className="page-container bg-blue baloo-da-2-tutor">
    <div className="card">
      <div className="card-header">
        <User className="icon-lg text-blue" />
        <h2>স্টুডেন্ট / অভিভাবক পোর্টাল</h2>
        <p>আপনার কাজটি বেছে নিন</p>
      </div>

      <div className="button-group">
        <button onClick={onPostTuition} className="btn btn-student">
          টিউশন পোস্ট করতে চাই
        </button>

        <button
          onClick={() => handleStudentAccountCheck(false)}
          className="btn btn-student"
        >
          টিউটরের সাথে যোগাযোগ করতে চাই
        </button>

        <button
          onClick={() => handleStudentAccountCheck(true)}
          className="btn btn-secondary"
        >
          আমার অ্যাকাউন্ট আছে
        </button>
      </div>

      <button
        onClick={() => setCurrentStep("role-selection")}
        className="link-back"
      >
        ← ফিরে যান
      </button>
    </div>
  </div>
);

//  Student Login
const StudentLogin = ({
  studentData,
  setStudentData,
  showPassword,
  setShowPassword,
  handleStudentLogin,
  setStudentStep,
}) => (
  <div
    className="page-container bg-blue baloo-da-2-tutor
"
  >
    <div className="card">
      <div className="card-header">
        <User className="icon-lg text-blue" />
        <h2>স্টুডেন্ট লগইন</h2>
        <p>আবারও স্বাগতম! লগইন করতে নিচের তথ্যগুলো দিন।</p>
      </div>

      <div className="form">
        <div className="input-wrapper">
          <Mail className="input-icon" />
          <input
            type="email"
            placeholder="ইমেইল অ্যাড্রেস"
            value={studentData.email}
            onChange={(e) =>
              setStudentData({ ...studentData, email: e.target.value })
            }
            required
          />
        </div>

        <div className="input-wrapper">
          <Lock className="input-icon" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="পাসওয়ার্ড"
            value={studentData.password}
            onChange={(e) =>
              setStudentData({ ...studentData, password: e.target.value })
            }
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="toggle-icon"
          >
            {showPassword ? (
              <EyeOff className="icon-sm" />
            ) : (
              <Eye className="icon-sm" />
            )}
          </button>
        </div>

        <button onClick={handleStudentLogin} className="btn btn-student">
          লগইন
        </button>
        <button
          type="button"
          onClick={() => setStudentStep("forgot-password")}
          className="link"
        >
          পাসওয়ার্ড ভুলে গেছেন?
        </button>
      </div>

      <div className="card-footer">
        <button
          onClick={() => setStudentStep("account-check")}
          className="link"
        >
          ← পেছনে যান
        </button>
      </div>
    </div>
  </div>
);

//  Student Signup
const StudentSignup = ({
  studentData,
  setStudentData,
  showPassword,
  setShowPassword,
  handleStudentSignup,
  setStudentStep,
}) => (
  <div
    className="page-container bg-blue baloo-da-2-tutor
"
  >
    <div className="card">
      <div className="card-header">
        <User className="icon-lg text-blue" />
        <h2>স্টুডেন্ট সাইন আপ</h2>
        <p>শুরু করতে একটি নতুন অ্যাকাউন্ট তৈরি করুন।</p>
      </div>

      <div className="form">
        <div className="input-wrapper">
          <UserCheck className="input-icon" />
          <input
            type="text"
            placeholder="পূর্ণ নাম"
            value={studentData.name}
            onChange={(e) =>
              setStudentData({ ...studentData, name: e.target.value })
            }
            required
          />
        </div>

        <div className="input-wrapper">
          <Mail className="input-icon" />
          <input
            type="email"
            placeholder="ইমেইল অ্যাড্রেস"
            value={studentData.email}
            onChange={(e) =>
              setStudentData({ ...studentData, email: e.target.value })
            }
            required
          />
        </div>

        {/* Phone Number */}
        <div className="input-wrapper">
          <Phone className="input-icon" />
          <input
            type="tel"
            placeholder="ফোন নম্বর (যেমন: 01XXXXXXXXX)"
            value={studentData.phone_number}
            onChange={(e) => {
              const next = e.target.value.trim();
              setStudentData((prev) => ({
                ...prev,
                phone_number: next,
                whatsapp_number: prev.whatsappSameAsPhone
                  ? next
                  : prev.whatsapp_number,
              }));
            }}
            required
          />
        </div>

        {/* WhatsApp Number + toggle */}
        <div className="input-wrapper">
          <MessageCircle className="input-icon" />
          <input
            type="tel"
            placeholder="হোয়াটসঅ্যাপ নম্বর"
            value={
              studentData.whatsappSameAsPhone
                ? studentData.phone_number
                : studentData.whatsapp_number
            }
            onChange={(e) =>
              setStudentData({
                ...studentData,
                whatsapp_number: e.target.value.trim(),
              })
            }
            disabled={studentData.whatsappSameAsPhone}
            required
          />
        </div>

        <label className="checkbox-row">
          <input
            type="checkbox"
            checked={studentData.whatsappSameAsPhone}
            onChange={(e) =>
              setStudentData((prev) => ({
                ...prev,
                whatsappSameAsPhone: e.target.checked,
                whatsapp_number: e.target.checked
                  ? prev.phone_number
                  : prev.whatsapp_number,
              }))
            }
          />
          <span>হোয়াটসঅ্যাপ নম্বরটি ফোন নম্বরের মতোই</span>
        </label>

        <div className="input-wrapper">
          <Lock className="input-icon" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="পাসওয়ার্ড"
            value={studentData.password}
            onChange={(e) =>
              setStudentData({ ...studentData, password: e.target.value })
            }
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="toggle-icon"
          >
            {showPassword ? (
              <EyeOff className="icon-sm" />
            ) : (
              <Eye className="icon-sm" />
            )}
          </button>
        </div>

        <button onClick={handleStudentSignup} className="btn btn-student">
          অ্যাকাউন্ট তৈরি করুন
        </button>
      </div>

      <div className="card-footer">
        <button
          onClick={() => setStudentStep("account-check")}
          className="link"
        >
          ← পেছনে যান
        </button>
      </div>
    </div>
  </div>
);

//  Tutor Login
const TutorLogin = ({
  tutorData,
  setTutorData,
  showPassword,
  setShowPassword,
  handleTutorLogin,
  setCurrentStep,
  navigate,
}) => (
  <div
    className="page-container bg-green baloo-da-2-tutor
"
  >
    <div className="card">
      <div className="card-header">
        <BookOpen className="icon-lg text-green" />
        <h2>টিউটর লগইন</h2>
        <p>আবারও স্বাগতম! লগইন করতে নিচের তথ্যগুলো দিন।</p>
      </div>

      <div className="form">
        <div className="input-wrapper">
          <Mail className="input-icon" />
          <input
            type="email"
            placeholder="ইমেইল অ্যাড্রেস"
            value={tutorData.email}
            onChange={(e) =>
              setTutorData({ ...tutorData, email: e.target.value })
            }
            required
          />
        </div>

        <div className="input-wrapper">
          <Lock className="input-icon" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="পাসওয়ার্ড"
            value={tutorData.password}
            onChange={(e) =>
              setTutorData({ ...tutorData, password: e.target.value })
            }
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="toggle-icon"
          >
            {showPassword ? (
              <EyeOff className="icon-sm" />
            ) : (
              <Eye className="icon-sm" />
            )}
          </button>
        </div>

        <button onClick={handleTutorLogin} className="btn btn-tutor">
          লগইন
        </button>

        <button
          type="button"
          onClick={() => setCurrentStep("tutor-forgot-password")}
          className="link"
        >
          পাসওয়ার্ড ভুলে গেছেন?
        </button>
        <button
          type="button"
          className="link"
          onClick={() => navigate("/tutor-submission")}
        >
          একাউন্ট নেই - টিউটর হতে চাই
        </button>
      </div>

      <div className="card-footer">
        <button
          onClick={() => setCurrentStep("role-selection")}
          className="link"
        >
          ← ভূমিকা বাছাই পেইজে ফিরে যান
        </button>
      </div>
    </div>
  </div>
);

/* ------------------------- MAIN LOGIN PAGE ------------------------- */

const UserLogin = () => {
  const [currentStep, setCurrentStep] = useState("role-selection");
  const [studentStep, setStudentStep] = useState("account-check");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [studentResetEmail, setStudentResetEmail] = useState("");
  const [tutorResetEmail, setTutorResetEmail] = useState("");

  const syncWhatsappIfNeeded = (nextPhone) => {
    setStudentData((prev) => ({
      ...prev,
      phone_number: nextPhone,
      whatsapp_number: prev.whatsappSameAsPhone
        ? nextPhone
        : prev.whatsapp_number,
    }));
  };

  const handleStudentForgotPassword = async () => {
    if (!studentResetEmail) return alert("আপনার ইমেইল লিখুন।");
    try {
      const res = await axios.post(
        "https://tn.server.goatteachers.com/api/auth/forgot-password",
        {
          email: studentResetEmail,
        },
      );
      alert(" রিসেট লিংক আপনার ইমেইলে পাঠানো হয়েছে।");
      setStudentStep("login");
    } catch (err) {
      alert("❌ রিসেট লিংক পাঠানো যায়নি। পরে আবার চেষ্টা করুন।");
    }
  };

  const handleTutorForgotPassword = async () => {
    if (!tutorResetEmail) return alert("আপনার ইমেইল লিখুন।");
    try {
      const res = await axios.post(
        "https://tn.server.goatteachers.com/api/auth/forgot-password",
        {
          email: tutorResetEmail,
        },
      );
      alert(" রিসেট লিংক আপনার ইমেইলে পাঠানো হয়েছে।");
      setCurrentStep("tutor-login");
    } catch (err) {
      alert("❌ রিসেট লিংক পাঠানো যায়নি। পরে আবার চেষ্টা করুন।");
    }
  };

  const { loginUser } = useContext(UserContext);
  const navigate = useNavigate();

  const [studentData, setStudentData] = useState({
    email: "",
    password: "",
    name: "",
    phone_number: "",
    whatsapp_number: "",
    whatsappSameAsPhone: true,
  });

  const [tutorData, setTutorData] = useState({
    email: "",
    password: "",
  });

  // Handlers
  const handleRoleSelection = (role) => {
    if (role === "student") {
      setCurrentStep("student-flow");
      setStudentStep("account-check");
    } else {
      setCurrentStep("tutor-login");
    }
  };

  const handleStudentAccountCheck = (hasAccount) => {
    setStudentStep(hasAccount ? "login" : "signup");
  };

  const handleStudentLogin = async () => {
    try {
      const response = await axios.post(
        "https://tn.server.goatteachers.com/api/students/login",
        {
          email: studentData.email,
          password: studentData.password,
        },
      );
      if (response.data.token) {
        loginUser(response.data.student, response.data.token, "student");
        navigate("/");
      }
    } catch (error) {
      alert("লগইন ব্যর্থ হয়েছে। ইমেইল ও পাসওয়ার্ড ঠিক আছে কিনা যাচাই করুন।");
    }
  };

  const handleStudentSignup = async () => {
    // Light validation for BD-style numbers: 11 digits starting with 01
    const phone = (studentData.phone_number || "").trim();
    const wa = studentData.whatsappSameAsPhone
      ? phone
      : (studentData.whatsapp_number || "").trim();

    const phoneOk = /^01\d{9}$/.test(phone);
    const waOk = /^01\d{9}$/.test(wa);

    if (!phoneOk) {
      alert("দয়া করে সঠিক ফোন নম্বর লিখুন (যেমন: 01XXXXXXXXX)।");
      return;
    }
    if (!waOk) {
      alert("দয়া করে সঠিক হোয়াটসঅ্যাপ নম্বর লিখুন (যেমন: 01XXXXXXXXX)।");
      return;
    }

    try {
      await axios.post(
        "https://tn.server.goatteachers.com/api/students/register",
        {
          name: studentData.name,
          email: studentData.email,
          password: studentData.password,
          phone_number: phone,
          whatsapp_number: wa,
        },
      );

      const response = await axios.post(
        "https://tn.server.goatteachers.com/api/students/login",
        {
          email: studentData.email,
          password: studentData.password,
        },
      );

      if (response.data.token) {
        loginUser(response.data.student, response.data.token, "student");
        navigate("/");
      }
    } catch (error) {
      alert(
        "সাইন আপ ব্যর্থ হয়েছে। এই ইমেইলটি আগে থেকেই ব্যবহার করা হয়ে থাকতে পারে।",
      );
    }
  };

  const handleTutorLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://tn.server.goatteachers.com/api/tutors/login",
        {
          email: tutorData.email,
          password: tutorData.password,
        },
      );
      if (response.data.token) {
        loginUser(response.data.tutor, response.data.token, "tutor");
        navigate("/");
      }
    } catch (error) {
      alert("ইমেইল বা পাসওয়ার্ড সঠিক নয়।");
    }
  };

  // Render
  if (currentStep === "role-selection")
    return <RoleSelection handleRoleSelection={handleRoleSelection} />;

  if (currentStep === "student-flow") {
    if (studentStep === "account-check")
      return (
        <StudentAccountCheck
          handleStudentAccountCheck={handleStudentAccountCheck}
          setCurrentStep={setCurrentStep}
          onPostTuition={() => navigate("/post-tuition")}
        />
      );
    if (studentStep === "login")
      return (
        <StudentLogin
          studentData={studentData}
          setStudentData={setStudentData}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          handleStudentLogin={handleStudentLogin}
          setStudentStep={setStudentStep}
        />
      );
    if (studentStep === "signup")
      return (
        <StudentSignup
          studentData={studentData}
          setStudentData={setStudentData}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          handleStudentSignup={handleStudentSignup}
          setStudentStep={setStudentStep}
        />
      );
  }

  if (studentStep === "forgot-password")
    return (
      <ForgotPassword
        email={studentResetEmail}
        setEmail={setStudentResetEmail}
        handleForgotPassword={handleStudentForgotPassword}
        backStep="login"
        setStep={setStudentStep}
      />
    );

  if (currentStep === "tutor-login")
    return (
      <TutorLogin
        tutorData={tutorData}
        setTutorData={setTutorData}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        handleTutorLogin={handleTutorLogin}
        setCurrentStep={setCurrentStep}
        navigate={navigate}
      />
    );

  if (currentStep === "tutor-forgot-password")
    return (
      <ForgotPassword
        email={tutorResetEmail}
        setEmail={setTutorResetEmail}
        handleForgotPassword={handleTutorForgotPassword}
        backStep="tutor-login"
        setStep={setCurrentStep}
      />
    );

  return <RoleSelection handleRoleSelection={handleRoleSelection} />;
};

export default UserLogin;
